// 网络版本：internal=内网版，external=外网版
const network = process.env.VUE_APP_NETWORK || 'external';
const isInternal = network === 'internal';

export default {
  title: "SCRM",
  // 是否内网版本
  isInternal,
  // 年报企业功能：所有环境可见
  showAnnualCompany: true,
  // 分值选项：内网版支持A/B/C，外网版只支持A/B
  markOptions: isInternal ? ['A', 'B', 'C'] : ['A', 'B']
};
